module.exports = __webpack_public_path__ + "img/amx-21.b4221479.webp";